import SwitchTableViewBar from './SwitchTableViewBar';

export default SwitchTableViewBar;
